'use client';
import Script from 'next/script';
import { Fragment } from 'react';

export function GoogleAnalyticsTag() {
  return (
    <Fragment>
      <Script
        id="google-analytics-tag"
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      ></Script>
      <Script
        id="google-analytics-tag-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}');
        `,
        }}
      ></Script>
    </Fragment>
  );
}
